// libs
import React, { useMemo } from 'react';

// components
import { Box } from '@lyearn/ui';

// context
import { ProviderContentContext } from '../context';
import Icon from '../Icon';
import Label from '../Label';
import Link from '../Link';
// types
import { ProviderContentComposition, ProviderContentProps } from '../types';

const ProviderContent: React.FC<ProviderContentProps> & ProviderContentComposition = ({
  provider,
  children,
  className,
}) => {
  const value = useMemo(() => ({ provider }), [provider]);

  return (
    <ProviderContentContext.Provider value={value}>
      <Box className={className}>{children}</Box>
    </ProviderContentContext.Provider>
  );
};

ProviderContent.Icon = Icon;
ProviderContent.Label = Label;
ProviderContent.Link = Link;

export default ProviderContent;
